import BrowseHistoryRemind from "@/vue_components/browseHistoryRemind.vue";

// 渲染浏览历史提示条组件
export default function(){
    const anchorEl = document.createElement('div')
    anchorEl.id = 'browseHistoryRemind'
    document.body.appendChild(anchorEl)
    new Vue({
        el: '#browseHistoryRemind',
        template: '<BrowseHistoryRemind></BrowseHistoryRemind>',
        components: {
            BrowseHistoryRemind
        }
    })
}